var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            {
              text: "Reports",
              path: { name: "admin-reports" },
            },
          ],
          name: "Incomplete Applications",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "mr-3" },
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("\n              Start Date:\n            "),
                          ]),
                          _vm._v(
                            "\n\n            " +
                              _vm._s(_vm.startDate) +
                              "\n\n            "
                          ),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onStartDateChanged },
                            model: {
                              value: _vm.filters.start_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "start_date", $$v)
                              },
                              expression: "filters.start_date",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("\n              End Date:\n            "),
                          ]),
                          _vm._v(
                            "\n\n            " +
                              _vm._s(_vm.endDate) +
                              "\n\n            "
                          ),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onEndDateChanged },
                            model: {
                              value: _vm.filters.end_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "end_date", $$v)
                              },
                              expression: "filters.end_date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              variant: "primary",
                              title: "Download CSV",
                              disabled: !_vm.reportRows.length,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reset Filters",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.resetFilters.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-counterclockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "header-right",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "mt-n2 d-flex flex-wrap align-items-center",
                    },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass:
                            "mr-2 my-2 incomplete-applications-search",
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              placeholder: "Name, email, company or license",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.loadReportData.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.filters.search,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filters,
                                  "search",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "filters.search",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.loadReportData },
                                },
                                [_vm._v("\n              Search\n            ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.stageOptions },
                        on: { change: _vm.loadReportData },
                        model: {
                          value: _vm.filters.stage,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "stage", $$v)
                          },
                          expression: "filters.stage",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No incomplete applications found",
            },
            scopedSlots: _vm._u([
              {
                key: "head(application_started_at)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "sortable-column",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("application_started_at")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.label) +
                            "\n          " +
                            _vm._s(
                              _vm.renderSortIcon("application_started_at")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(last_activity_at)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "sortable-column",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("last_activity_at")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.label) +
                            "\n          " +
                            _vm._s(_vm.renderSortIcon("last_activity_at")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(applicant)",
                fn: function (data) {
                  return [
                    _c("div", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.applicant_name || "—") +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.email || "—") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(phone)",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(data.item.phone || "—") + "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(company)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(data.item.company_name || "—") +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    data.item.license_number
                      ? _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n          License: " +
                              _vm._s(data.item.license_number) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(state)",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(data.item.state || "—") + "\n      "
                    ),
                  ]
                },
              },
              {
                key: "cell(stage)",
                fn: function (data) {
                  return [
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.getStageVariant(data.item.stage),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getStageLabel(data.item.stage)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(api_key_status)",
                fn: function (data) {
                  return [
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.getStatusVariant(
                            data.item.api_key_status
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getApiKeyStatusLabel(data.item.api_key_status)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(account_status)",
                fn: function (data) {
                  return [
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.getStatusVariant(
                            data.item.account_status
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getAccountStatusLabel(
                                data.item.account_status
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(application_started_at)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formatDate(data.item.application_started_at)
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formatTime(data.item.application_started_at)
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(last_activity_at)",
                fn: function (data) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(data.item.last_activity_at)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small text-muted" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatTime(data.item.last_activity_at)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(incomplete_for)",
                fn: function (data) {
                  return [
                    data.item.application_started_at
                      ? _c(
                          "span",
                          {
                            class: _vm.getIncompleteAgeClass(
                              data.item.application_started_at
                            ),
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.getIncompleteAge(
                                    data.item.application_started_at
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c("span", [_vm._v("—")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }